import { render, staticRenderFns } from "./SettingsIndexesList.vue?vue&type=template&id=c4884f58&"
import script from "./SettingsIndexesList.vue?vue&type=script&lang=js&"
export * from "./SettingsIndexesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports